<!--
 * @Author: Tahiti
 * @Date: 2025-11-14 17:05:03
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-23 16:22:49
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/CreditRequired.vue
-->

<template>
    <div class="my-4 credit-required-container">
        <div v-if="cost_credit?.show_discount"
            class="flex flex-col items-start justify-center bg-[#1C1C20] border border-[#ffffff0f] rounded-[10px]">
            <label class="w-full p-3 flex items-center text-[11px] text-[#666] font-medium">
                <span> {{ t('setting_tools.current_cost') }} </span>
            </label>
            <div v-if="isLoggedIn && cost_credit?.can_use_discount"
                class="w-full p-3 flex justify-between items-center text-white text-xs border-t border-[#ffffff0f]">
                <span class="text-text-active">
                    <span v-if="!speed_loading" class="mx-1 text-sm">{{
                        cost_credit?.discount_credits
                        }}</span>
                    <el-icon v-else class="animate-spin mx-1">
                        <Loading />
                    </el-icon>
                    <span class="text-[10px]">{{ t('tools.credits') }}</span>
                </span>
                <span class="text-text-active text-[11px] flex items-center">
                    <img src="https://static.weryai.com/growth/image/weryai_89a6e800dafff66bc78a361802cfde96.webp"
                        alt="VIP icon" class="w-5 h-auto mr-[2px]" />
                    {{
                        t('setting_tools.discount_percent', {
                            discount: cost_credit?.discount_percent,
                        })
                    }}
                </span>
            </div>
            <div v-else
                class="w-full flex flex-col justify-center items-center text-white text-xs border-t border-[#ffffff0f]">
                <div class="w-full p-3 flex items-center justify-between">
                    <span class="text-[11px]">
                        {{ t('setting_tools.standard_price') }}
                    </span>
                    <span class="flex items-center justify-center">
                        <span v-if="!speed_loading" class="mx-1 text-sm">{{
                            cost_credit?.original_credits
                            }}</span>
                        <el-icon v-else class="animate-spin mx-1">
                            <Loading />
                        </el-icon>
                        <span class="text-[10px]">{{
                            t('tools.credits')
                            }}</span>
                    </span>
                </div>

                <div class="w-full h-[36px] relative px-3 py-[10px] flex items-center justify-between">
                    <img class="absolute top-0 left-0 w-full h-full z-[1]"
                        src="https://static.weryai.com/growth/image/weryai_b785ae78d167e099b449deb535afb7fb.webp"
                        alt="bg" />
                    <div class="relative w-full z-[2] flex items-center justify-between">
                        <div class="flex items-center justify-start">
                            <img src="https://static.weryai.com/growth/image/weryai_f3e1f01ae4e1d4ab76121391714019c9.webp"
                                alt="VIP icon" class="w-5 h-auto mr-[2px]" />

                            <span class="vip-text">
                                {{ t('setting_tools.vip_has_half_price') }}
                            </span>
                            <img src="https://static.weryai.com/growth/image/weryai_24a94d1fa41cd661a990b41cd48a2518.webp"
                                alt="arrow " class="w-3 h-auto" />
                        </div>
                        <span class="flex items-center justify-center text-[#EAB308]">
                            <span v-if="!speed_loading" class="mx-1 text-sm">{{
                                cost_credit?.discount_credits
                                }}</span>
                            <el-icon v-else class="animate-spin mx-1">
                                <Loading />
                            </el-icon>
                            <span class="text-[10px]">{{
                                t('tools.credits')
                                }}</span>
                            <button
                                class="bg-[#EAB308] ml-1 text-xs px-3 py-[5px] text-black h-[24px] rounded-[4px] hover:opacity-80 transition-all transition-300"
                                @click="emitOpenGoodsModal('yearly')">
                                {{ t('setting_tools.start_vip') }}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else
            class="flex flex-col items-start justify-start bg-[#1C1C20] border border-[#ffffff0f] rounded-[10px]">
            <label class="w-full p-3 flex items-center text-[11px] text-[#666] font-medium">
                <span> {{ t('setting_tools.current_cost') }} </span>
            </label>
            <div class="w-full p-3 flex items-center justify-start text-white text-xs border-t border-[#ffffff0f]">
                <label class="flex items-center text-xs text-white font-semibold">
                    <img src="~/assets/images/common/coin.webp" alt="Credit icon" aria-hidden="true" role="presentation"
                        class="w-4 h-4 mr-1" />
                </label>
                <div class="flex items-center text-white text-xs">
                    <span v-if="!speed_loading" class="mx-1">{{
                        cost_credit?.original_credits || 0
                        }}</span>
                    <el-icon v-else class="animate-spin mx-1">
                        <Loading />
                    </el-icon>
                    <span>{{ t('tools.credits') }}</span>
                </div>
            </div>
        </div>
        <button
            class="my-5 generate bg-create-btn w-full disabled:opacity-50 disabled:cursor-not-allowed h-[44px] text-black rounded-[10px] flex items-center justify-center disabled:hover:scale-100 hover:scale-105 transition-all duration-300 cursor-pointer gap-2"
            :disabled="props.create_btn_disable || props.loading || speed_loading
                " @click="handleCreate">
            <template v-if="props.loading">
                <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                </svg>
                <span>{{ t('batchTools.pleaseWaiting') }}</span>
            </template>
            <template v-else>
                <img src="~/assets/images/common/create_btn.svg" alt="Create button icon" aria-hidden="true"
                    role="presentation" class="w-6 h-6" />
                <span>{{ t('tools.createButton') }}</span>
            </template>
        </button>
        <div v-if="!isLoggedIn && LOGIN_ENTRY_ENABLED" class="w-full justify-center flex items-center login-reminder">
            <img class="w-5 h-5"
                src="https://static.weryai.com/growth/image/weryai_ce29b49010526e7fa8e91d971a726de4.webp"
                alt="Gift icon" aria-hidden="true" role="presentation" />
            <span class="text-xs text-white ml-[5px] mr-[10px]">{{
                t('common.loginToGetFree')
                }}</span>
            <div class="flex items-center text-sm font-semibold text-text-active cursor-pointer hover:underline hover:scale-110 transition-all duration-300"
                @click="handleTryNow">
                <span class="mr-[5px]">{{ t('common.tryNow') }}</span>
                <img class="w-3 h-3"
                    src="https://static.weryai.com/growth/image/weryai_404732b1381449b983bc6509b6b7ce3d.webp"
                    alt="Arrow icon" aria-hidden="true" role="presentation" />
            </div>
        </div>
    </div>
    <div class="credit-placeholder md:hidden" aria-hidden="true"></div>
</template>
<script setup lang="ts">
import { ref, computed, onUnmounted, watch } from 'vue'
import { Loading } from '@element-plus/icons-vue'
import { useI18n } from '~/composables/useI18n'
import { LOGIN_ENTRY_ENABLED } from '~/utils/feature-flags'
import type { SettingType } from '@/types'
import { useCreateStore } from '~/stores/create'
import { emitter, showLoginModal, emitOpenGoodsModal } from '~/utils/emitter'
import { useUserStore } from '~/stores/user'

const userStore = useUserStore()
const isLoggedIn = computed(() => userStore.isLoggedIn)
const balance = computed(() => userStore.balance)
const handleTryNow = () => {
    showLoginModal()
}
const { t, locale } = useI18n()

const createStore = useCreateStore()

// 标准化分辨率入参，统一成像素高度字符串
const normalizeResolution = (val: any) => {
    if (val === undefined || val === null) return undefined
    const s = String(val).toLowerCase().trim()
    // 常见格式：'1080p' -> '1080'
    if (s.endsWith('p')) return s.replace('p', '')
    // 文案映射：'2k'、'4k' -> 数值像素高度
    if (s === '2k') return '2160'
    if (s === '4k') return '4320'
    // 其他情况尽量提取数字
    const onlyNums = s.replace(/[^\d]/g, '')
    return onlyNums || s
}

const cost_credit = computed(() => {
    // 如果直接传入了 credit，优先使用（特效模板场景）ai音乐
    if (props.credit !== undefined && props.credit !== null) {
        return {
            original_credits: props.credit,
            discount_credits: 10,
            can_use_discount: false,
            show_discount: false,
            discount_percent: 5,
        }
    }

    // 否则从 store 获取
    return createStore.cost_credit_data?.[props.workflowType]?.credits ?? 0
})

const props = withDefaults(
    defineProps<{
        type: SettingType
        create_btn_disable: boolean
        workflowType: string
        m?: string
        p?: string
        n?: number
        ga?: boolean
        t?: any
        r?: any
        v?: string
        r1?: string
        et?: string
        loading?: boolean
        credit?: number // 直接传入积分值（特效模板使用）
        extraCreditParams?: Record<string, unknown>
        creditParamsWatchKey?: string
    }>(),
    {
        type: 'text_to_image',
        create_btn_disable: false,
        workflowType: '',
        m: '',
        p: '',
        n: 1,
        t: 0,
        ga: false,
        r: '720p',
        v: '',
        r1: '',
        loading: false,
        credit: undefined,
        extraCreditParams: () => ({}),
        creditParamsWatchKey: '',
    }
)

// 点击创建
const handleCreate = () => {
    // 向父组件发送创建事件
    emitter.emit('click-create')
}

// 防抖定时器
let debounceTimer: NodeJS.Timeout | null = null

const speed_loading = ref(false)
// 更新积分需求的函数
const updateCreditRequired = async () => {
    console.log('props', props)

    // 如果直接传入了 credit，不需要调用接口（特效模板场景）
    if (props.credit !== undefined && props.credit !== null) {
        return
    }

    // 只有在 workflowType 有值时才调用
    // 这样避免初始化时用不完整的参数调用
    if (props.workflowType) {
        try {
            speed_loading.value = true
            const res = await createStore.getCreditRequiredData({
                workflowType: props.workflowType,
                m: props.m,
                p: props.p,
                n: props.n,
                ga: props.ga,
                r: normalizeResolution(props.r),
                t: props.t,
                v: props.v,
                r1: props.r1,
                ...(props.et !== undefined && { et: props.et }),
                ...(props.extraCreditParams || {}),
            })
        } catch (error) {
            console.log('error', error)
        } finally {
            speed_loading.value = false
        }
    }
}

watch(
    [
        () => props.workflowType,
        () => props.m,
        () => props.p,
        () => props.n,
        () => props.ga,
        () => props.r,
        () => props.t,
        () => props.v,
        () => props.r1,
        () => props.et,
        () =>
            props.creditParamsWatchKey ||
            JSON.stringify(props.extraCreditParams || {}),
    ],
    () => {
        // 清除之前的定时器
        if (debounceTimer) {
            clearTimeout(debounceTimer)
        }
        // 设置新的防抖定时器，延迟 100ms 执行
        debounceTimer = setTimeout(() => {
            updateCreditRequired()
        }, 100)
    },
    {
        immediate: true,
        flush: 'post',
    }
)

// 在生视频页面登录需要更新积分展示
watch(
    () => userStore.isLoggedIn,
    newVal => {
        if (newVal) {
            updateCreditRequired()
        }
    }
)

// 这里利用余额更新来判断提交任务后 下次是否还有折扣价展示
watch(
    () => balance.value,
    newVal => {
        if (newVal) {
            updateCreditRequired()
        }
    }
)

// 组件卸载时清理定时器
onUnmounted(() => {
    if (debounceTimer) {
        clearTimeout(debounceTimer)
        debounceTimer = null
    }
})
</script>
<style scoped lang="less">
.credit-required-container {
    @media (max-width: 768px) {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 20;
        /* 提高 z-index 确保在 iOS Safari 上正确显示 */
        background: #111113;
        padding: 12px 16px;
        margin: 0 !important;
        border-top: 1px solid rgba(255, 255, 255, 0.05);
        padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
        box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.5);
        /* 强制创建新的堆叠上下文，避免被 -webkit-overflow-scrolling 影响 */
        transform: translateZ(0);
        -webkit-transform: translateZ(0);

        .generate {
            margin-top: 12px !important;
            margin-bottom: 0 !important;
        }

        .login-reminder {
            margin-top: 8px !important;
            margin-bottom: 4px !important;
        }
    }

    @media (min-width: 769px) {
        position: sticky;
        bottom: 0;
        z-index: 8;
        background: #101012;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-bottom: 0 !important;
        border-top: 1px solid rgba(255, 255, 255, 0.05);
    }
}

.credit-placeholder {
    display: none;

    @media (max-width: 768px) {
        display: block;
        height: 231px;
        flex-shrink: 0;
    }
}

.generate {
    &:hover:not(.disabled) {
        transform: translateY(-2px);
        box-shadow: 0 12px 40px rgba(153, 247, 104, 0.5);
    }
}

.vip-text {
    background: linear-gradient(94deg, #fdffb5 -3.87%, #f7cc68 99.21%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
